import {frontend} from 'pageflow-scrolled/frontend';

import {LinkListFooter} from './LinkListFooter';

frontend.widgetTypes.register('linkListFooter', {
  component: LinkListFooter
});
